<router-outlet />
<app-alert />
<app-confirm />
